import ServicePageTemplate from '../ServicePageTemplate';
import { homeFaqs } from '../../../mocks/faqs';

export default function HardscapeDesign() {
  return (
    <ServicePageTemplate
      heroTitle="Hardscape Design & Installation"
      heroSubtitle="End-to-end hardscape design and professional installation for residential and commercial properties throughout Tampa Bay."
      heroImage="https://www.parksidepavers.com/files/projects/16/thumb/thumb_IMG%5F2840%2Dlanding%2Ejpg"
      serviceBreakdownTitle="Our Hardscape Design Services"
      serviceBreakdown={[
        { title: 'Full-Property Design', desc: 'Comprehensive hardscape design that ties all outdoor elements together cohesively.', icon: 'ri-pencil-ruler-2-line' },
        { title: 'Commercial Hardscaping', desc: 'Large-scale paver installation for commercial properties, retail, and HOA communities.', icon: 'ri-building-4-line' },
        { title: 'Material Consultation', desc: 'Expert guidance on material selection to match your style, climate, and budget goals.', icon: 'ri-stack-line' },
        { title: 'Project Management', desc: 'From permits to final walkthrough, we manage every phase of your hardscape project.', icon: 'ri-calendar-check-line' },
      ]}
      aiAnswerText="Hardscape design and installation encompasses all non-plant elements of your outdoor environment — pavers, retaining walls, walkways, pool decks, and outdoor living structures. Parkside Pavers offers complete design-build services for residential and commercial clients throughout Tampa Bay, handling everything from initial concept to final installation with ICPI-certified craftsmanship and premium materials."
      aiAnswerBenefits={[
        'Complete design-build service',
        'Residential & commercial projects',
        'ICPI certified installation',
        'Premium material selection',
        'Coordinated project management',
        'Long-term structural integrity',
      ]}
      faqs={[
        { question: 'What is hardscaping?', answer: 'Hardscaping refers to the non-living, structural elements of your outdoor space — including paver patios, driveways, walkways, retaining walls, and outdoor living structures. It\'s the foundation that defines how your outdoor areas look and function.' },
        { question: 'Do you handle commercial hardscape projects?', answer: 'Yes. Parkside Pavers works with commercial property owners, HOA communities, and developers throughout Tampa Bay. We have the crew size and equipment to handle large-scale commercial hardscape installations efficiently.' },
        ...homeFaqs.slice(1),
      ]}
      seoCity="Tampa Bay"
    />
  );
}
